<div class="container p-2">
  <div class="mat-dialog-content">
    <p>Are you sure you want to cancel this trip?</p>
  </div>

  <div class="flex_container" mat-dialog-actions>
    <button
      class="ex1"
      mat-button
      [disabled]="loading"
      (click)="cancelTrip()"
    >
      Yes
    </button>
    <button class="ext" mat-button mat-dialog-close [disabled]="loading">
      No
    </button>
  </div>
</div>
